import { render, staticRenderFns } from "./validate-code.vue?vue&type=template&id=ee94042a&scoped=true"
import script from "./validate-code.vue?vue&type=script&lang=js"
export * from "./validate-code.vue?vue&type=script&lang=js"
import style0 from "./validate-code.vue?vue&type=style&index=0&id=ee94042a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee94042a",
  null
  
)

export default component.exports